/**
 * @typedef {Object} AppStateSettingKeys
 * @property {boolean} navFontColorLight
 * @property {boolean} navLightMode
 * @property {boolean} showCartIcon
 * @property {boolean} showSearchIcon
 */

export const initialSettings = {
  navFontColorLight: false,
  navLightMode: false,
  showCartIcon: false,
  showSearchIcon: false,
};

/**
 * @type {AppStateSettingKeys}
 */
export const inputLabels = (() => {
  const target = {};
  for (const setting in initialSettings) {
    if (Object.hasOwn(initialSettings, setting)) {
      target[setting] = setting;
    }
  }
  return target;
})();

export function settingsReducer(state, action) {
  return {
    ...state,
    [action.name]: action.value === 'default' ? undefined : action.value,
  };
}

/**
 * Synchronous initial reducer state from the page's own blok, so SSG/SSR output already
 * reflects these settings instead of the hardcoded `false` defaults — Layout.jsx's
 * dispatchSetting effects still run afterward for editor live-preview and (for
 * navFontColorLight specifically) the scroll-driven override.
 * @param {*} blok
 * @returns {AppStateSettingKeys}
 */
export function buildInitialSettings(blok = {}) {
  return {
    ...initialSettings,
    navFontColorLight: blok.navLightMode || false,
    navLightMode: blok.navLightMode || false,
    showCartIcon: blok.showCartIcon || false,
    showSearchIcon: blok.showSearchIcon || false,
  };
}
